module.exports = __webpack_public_path__ + "img/head-banner.4b4742fd.jpg";